const PLP_Constants = {
  contentType: 'product',
  data_source_mode_option: {
    API_DATA: 'API_DATA',
    CONTENTFUL_DATA: 'CONTENTFUL_DATA',
  },
  filter_list: [
    {
      filter: {},
      sort: null,
      page: 1,
    },
  ],
  lazy_load_consts: {
    current_page: 1,
    per_page: 12,
    total_page: '',
  },
  algoliaQueryFormat: {
    hitsPerPage: 12,
    page: 0,
    attributesToRetrieve: [
        'gtin',
        'heroImage',
        'heroImageTitle',
        'productName',
        'slug',
        'productShortName',
        'shortDescription',
        'total_review_count',

        'ratingAndReviewId',

        'rating',
        'GAPopularityCount',
        'productCategoryType',
        'variantsgtin',
      ],
    facets:[],
  },
  sorting_dropdown_list: {
    'rating+': {
      name: 'MAIS BEM AVALIADOS',
      value: 'rating+',
      sort_field: 'rating',
      sort_direction: 'desc',
    },
    newest: {
      name: 'ÚLTIMOS LANÇAMENTOS',
      value: 'newest',
      sort_field: 'prodAddDate',
      sort_direction: 'desc',
    },
    'a-z': {
      name: 'NOME DE A-Z',
      value: 'a-z',
      sort_field: 'productName',
      sort_direction: 'asc',
    },
    'z-a': {
      name: 'NOME DE Z-A',
      value: 'z-a',
      sort_field: 'productName',
      sort_direction: 'desc',
    },
  },
};

export default PLP_Constants;
